document.addEventListener('DOMContentLoaded', () => {
  const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
  const thumbnails = document.querySelectorAll('[data-product-thumbnail]');
  const mediaItems = document.querySelectorAll('[data-product-media]');

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const selectedId = thumbnail.dataset.mediaId;
      mediaItems.forEach((item) => {
        const selected = item.dataset.productMedia === selectedId;
        item.hidden = !selected;
        item.classList.toggle('is-active', selected);
        const video = item.querySelector('video');
        if (video) {
          if (selected) video.play().catch(() => {});
          else video.pause();
        }
      });
      thumbnails.forEach((item) => item.classList.toggle('is-active', item === thumbnail));
    });
  });

  const guestCount = document.querySelector('[data-event-guest-count]');
  const cartQuantity = document.querySelector('[data-event-cart-quantity]');
  if (guestCount && cartQuantity) {
    const syncGuestQuantity = () => {
      const guests = Math.max(6, Math.min(30, Number.parseInt(guestCount.value, 10) || 6));
      guestCount.value = String(guests);
      cartQuantity.value = String(guests);
    };
    guestCount.addEventListener('input', syncGuestQuantity);
    guestCount.addEventListener('change', syncGuestQuantity);
    syncGuestQuantity();
  }

  const variantSelect = document.querySelector('[data-product-variant-select]');
  const price = document.querySelector('[data-product-price]');
  const submit = document.querySelector('[data-product-submit]');
  const waitlist = document.querySelector('[data-event-waitlist]');

  if (!variantSelect || !submit) return;

  const updateVariantState = () => {
    const option = variantSelect.options[variantSelect.selectedIndex];
    const available = option.dataset.available === 'true';
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    submit.disabled = !available;
    submit.textContent = available ? (isEnglish ? 'Add to Cart' : 'In den Warenkorb') : (isEnglish ? 'Sold Out' : 'Ausverkauft');
    if (waitlist) waitlist.hidden = available;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  };

  variantSelect.addEventListener('change', updateVariantState);
});
